const triggerEvent = (event, opts = {}) => {
  window.dataLayer.push({ event, ...opts })
}

export default triggerEvent
